(function () {
    'use strict';

    angular.module('mgpCorregedoriaApp').controller('MenuController', MenuController);

    function MenuController($scope) {
        $scope.boxOpen = true;
        $scope.toggle = function () {
            $scope.boxOpen = !$scope.boxOpen;
        };
        $scope.toothlet = function () {
            $(".left-side, .right-side, .left-bar, nav.navbar.navbar-default.navbar-fixed-top, .content-header h1").toggleClass("stash");
        };

    }

})();